module.exports = __webpack_public_path__ + "static/media/smart-goals-large@3x.8771fb14.png";